import { pageBannerEndId } from 'Core/variables';

let $filtersItems = $('.filters-items'),
	$filtersSubmit = $('.js-filters-submit'),
	$filtersTrigger = $('.js-filters-trigger'),
	$highlightedTags = $('.js-highlighted-tags'),
	$resultsOrder = $('#results_order');

const filterTrigger = function () {
	$filtersTrigger.on('click', function () {
		$filtersItems.slideToggle('slow');
	});
};

const filterSubmit = function () {
	let $parentForm = $filtersSubmit.closest('form');

	$filtersSubmit.on('click', function () {
		$parentForm.submit();
	});
};

const filterRemove = function () {
	$highlightedTags.on('click', '.js-remove-highlighted-tag-item', function () {
		let $this = $(this),
			id = $this.data('id'),
			$parentForm = $this.closest('form'),
			$checkedItem = $parentForm.find('input:checkbox[value="' + id + '"]'),
			$filterItemRemovedMessage = $parentForm.find('.js-search-resubmit-message');

		$checkedItem[0].checked = false;
		$this.remove();
		$filterItemRemovedMessage.addClass('show');
	});
};

const formSubmission = function () {
	let $parentForm = $filtersSubmit.closest('form');

	$parentForm.on('submit', function (event) {
		let $form = $(event.target),
			$checkboxItems = $form.find('input[type=checkbox]:checked'),
			$searchTerm = $form.find('input[type=text]'),
			$resultsOrder = $form.find('#results_order'),
			qStringObj = processCheckboxes($checkboxItems);

		event.preventDefault();

		// add the search term to the object
		if ($searchTerm && $searchTerm[0].value) {
			qStringObj[$searchTerm[0].name] = $searchTerm[0].value;
		}

		// add the results order to the object
		if ($resultsOrder && $resultsOrder[0].value) {
			qStringObj[$resultsOrder[0].name] = $resultsOrder[0].value;
		}

		let qString = buildQueryString(qStringObj);

		window.location.href = buildUrl(qString);
	});
};

const addSelectedFilter = function () {
	let $searchResubmitMessage = $highlightedTags.children('.js-search-resubmit-message');

	$('input:checkbox').on('click', function () {
		let $this = $(this);

		if ($this[0].checked) {
			$highlightedTags.prepend('<li class="highlighted-tag-item js-remove-highlighted-tag-item" data-id="' + $this[0].value + '">' + $this.parent().text().trim() + '</li>');
		} else {
			$highlightedTags
				.children()
				.filter(function () {
					return $(this).data('id') === +$this[0].value;
				})
				.remove();
		}

		$searchResubmitMessage.addClass('show');
	});
};

const clearFilter = function () {
	let $clearFilter = $('.js-clear-filter');

	$clearFilter.each(function (index, el) {
		$(el).on('click', function (event) {
			let $this = $(this),
				$filterTagList = $this.closest('.tag-list'),
				$checkedItems = $filterTagList.find('input[type=checkbox]:checked');

			event.preventDefault();

			$checkedItems.each(function (index, el) {
				el.checked = false;

				$highlightedTags
					.children()
					.filter(function () {
						return $(this).data('id') === +el.value;
					})
					.remove();
			});
		});
	});
};

const processCheckboxes = function ($items) {
	let obj = {};

	$items.each(function (index, el) {
		let singleName = 'tags',
			checkboxValue = el.value;

		if (obj[singleName]) {
			obj[singleName] += ',' + checkboxValue;
		} else {
			obj[singleName] = checkboxValue;
		}
	});

	return obj;
};

const resultsOrderChanged = function () {
	let $searchResubmitMessage = $highlightedTags.children('.js-search-resubmit-message');

	$resultsOrder.on('change', function () {
		$searchResubmitMessage.addClass('show');
	});
};

const buildQueryString = function (obj) {
	let qString = Object.keys(obj)
		.map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]))
		.join('&');

	return qString;
};

const buildUrl = function (qString) {
	let url = window.location.href;

	if (url.indexOf('?') > 0) {
		url = url.substring(0, url.indexOf('?'));
	}

	if (url.indexOf('#') > 0) {
		url = url.substring(0, url.indexOf('#'));
	}

	url += qString ? '?' + qString : '';
	url += '#' + pageBannerEndId;

	return url;
};

export const FilterWatcher = function () {
	$(document).ready(function () {
		if ($filtersTrigger.length) {
			filterTrigger();
			filterSubmit();
			formSubmission();
			clearFilter();
			filterRemove();
			addSelectedFilter();
			resultsOrderChanged();
		}
	});
};
